import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import { sendAgreementsToDGCSAction } from '../../../../services/request';
import { useApplication } from '../ApplicationsContext';
import EmailIcon from '@mui/icons-material/Email';
import SendTemplateEmailModal from '../../generics/components/SendTemplateEmailModal';

export default function ApplicationsSendAgreementsToDGCSModal() {
  const { rows } = useApplication();
  const [open, setOpen] = useState(false);

  return <Box
    sx={{ p: 3, width: '100%',
      display: 'flex',
      flexDirection: 'row' }}>
    <Button fullWidth variant = "contained" endIcon={<EmailIcon />} onClick={() => setOpen(true)}>Wyślij umowy do DGCS</Button>
    {open ? <SendTemplateEmailModal rows={rows} sendMessages={sendAgreementsToDGCSAction} setOpen={setOpen} notificationType="SATD" /> : null}
  </Box>;
}
